// ==================
// NAME
// ==================
const name = "Message";

// ==================
// DATA
// ==================
const data = () => ({
	show: false
});

// ==================
// PROPS
// ==================
const props = {
	message: {
		type: Object,
		required: true,
		default: {
			sender: {},
			discussion: {}
		}
	}
};

// ==================
// METHODS
// ==================
const showMessage = () => {
	this.show = true;
	this.$store.commit("addMessage", this.message);
};

export default {
	name,
	data,
	props,
	methods: {
		showMessage
	}
};
